(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/theme-helpers/assets/javascripts/is-date-hours-diff.js') >= 0) return;  svs.modules.push('/components/themes/theme-helpers/assets/javascripts/is-date-hours-diff.js'); "use strict";

(function (svs) {
  var getDifferenceBetweenDates = svs.themes.getDifferenceBetweenDates;

  var isDateHoursDiff = function isDateHoursDiff(date, hours) {
    var dateToCheck = new Date(date);
    dateToCheck.setHours(dateToCheck.getHours() + hours);
    return getDifferenceBetweenDates(dateToCheck, Date.now(), 'hours') < 0;
  };

  svs.themes.isDateHoursDiff = isDateHoursDiff;
})(svs);
 })(window);